import { render, staticRenderFns } from "./TabItemSection.vue?vue&type=template&id=6d255561&scoped=true&"
import script from "./TabItemSection.vue?vue&type=script&lang=js&"
export * from "./TabItemSection.vue?vue&type=script&lang=js&"
import style0 from "./TabItemSection.vue?vue&type=style&index=0&id=6d255561&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d255561",
  null
  
)

export default component.exports